import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { useTranslation } from "react-i18next";
import { useAuth } from "hooks‬/Auth";
import { privateRoutes } from "constant/route/privateRoutes";
import { useFeatureAccess } from "hooks‬/custome-hooks/useFeatureAccess";
import { featureObject } from "helpers/privileges/utils";

const SidebarMenuMain = () => {
  const { t } = useTranslation();

  const { companySubscriptionDetails } = useAuth();

  const company = useFeatureAccess(featureObject.COMPANY);
  const companyBranches = useFeatureAccess(featureObject.BRANCH);
  const rebrand = useFeatureAccess(featureObject.REBRAND);
  const subscription = useFeatureAccess(featureObject.SUBSCRIPTION);
  const subscriptionUsage = useFeatureAccess(featureObject.SUBS_USG);
  const users = useFeatureAccess(featureObject.USERS);
  const roles = useFeatureAccess(featureObject.USR_ROLE);

  return (
    <>
      <SidebarMenuItem
        to="/dashboard"
        icon="element-equal"
        title={t("DASHBOARD")}
        fontIcon="bi-app-indicator"
      />

      {(users.canRead || roles.canRead) && (
        <SidebarMenuItemWithSub
          to="/user-management"
          title={t("USER.MANAGEMENT")}
          icon="profile-user"
          fontIcon="bi-person"
        >
          {users.canRead && (
            <SidebarMenuItem
              to="user-management/users"
              title={t("USERS")}
              hasBullet={true}
            />
          )}
          {roles.canRead && (
            <SidebarMenuItem
              to="user-management/roles"
              title={t("ROLES")}
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}

      {(company.canRead || companyBranches.canRead || rebrand.canRead) && (
        <SidebarMenuItemWithSub
          to="/company-managment"
          title={t("COMPANY.MANAGEMENT")}
          icon="office-bag"
          fontIcon="bi-person"
        >
          {company.canRead && (
            <SidebarMenuItem
              to="company-management/profile"
              title={t("COMPANY.PROFILE")}
              hasBullet={true}
            />
          )}
          {companyBranches.canRead && (
            <SidebarMenuItem
              to="company-management/company-branches"
              title={t("COMPANY.BRANCHES")}
              hasBullet={true}
            />
          )}
          {rebrand.canRead && (
            <SidebarMenuItem
              to="company-management/rebranding"
              title={t("COMPANY.REBRANDING")}
              hasBullet={true}
            />
          )}
          {subscription.canRead && (
            <SidebarMenuItem
              to="company-management/integrations"
              title={"Integrations"}
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}

      {(subscription.canRead || subscriptionUsage.canRead) && (
        <SidebarMenuItemWithSub
          to="/pricing"
          title={"Pricing & Plans"}
          icon="price-tag"
          fontIcon="bi-person"
        >
          {subscription.canRead && (
            <SidebarMenuItem
              to="/pricing/plans"
              title={"Pricing"}
              hasBullet={true}
            />
          )}
          {subscriptionUsage.canRead &&
            companySubscriptionDetails?.havePlan && (
              <SidebarMenuItem
                to={privateRoutes.subscriptionUsage}
                title={"Subscription Usage"}
                hasBullet={true}
              />
            )}
        </SidebarMenuItemWithSub>
      )}
    </>
  );
};

export { SidebarMenuMain };
